"use client";

import React, { Suspense } from "react";
import { useChatNotification } from "@/hooks/message/useChatNotification.hooks";

interface ChatNotificationWrapperProps {
  children: (hasUnreadMessages: boolean, clearNotification: () => void) => React.ReactNode;
}

const ChatNotificationInternal: React.FC<ChatNotificationWrapperProps> = ({ children }) => {
  const { hasUnread: hasUnreadMessages, clearNotification } = useChatNotification();
  return <>{children(hasUnreadMessages, clearNotification)}</>;
};

const ChatNotificationWrapper: React.FC<ChatNotificationWrapperProps> = ({ children }) => {
  return (
    <Suspense fallback={<>{children(false, () => {})}</>}>
      <ChatNotificationInternal>{children}</ChatNotificationInternal>
    </Suspense>
  );
};

export default ChatNotificationWrapper;